import type { XMLParseCallback } from '../containers/xml-editing/services/common';
import { XML_FILE_TYPE } from './constants';
import { hasXmlParseErrorElement } from './xmlParseError';

export type DomParserLike = Pick<DOMParser, 'parseFromString'>;

export const parseXmlWithDomParser = (
    content: string,
    contentType: DOMParserSupportedType = XML_FILE_TYPE,
    parser: DomParserLike = new DOMParser()
): Document => parser.parseFromString(content, contentType);

export const createXmlParser =
    (parser: DomParserLike = new DOMParser(), contentType: DOMParserSupportedType = XML_FILE_TYPE): XMLParseCallback =>
    (content: string): Document =>
        parseXmlWithDomParser(content, contentType, parser);

export const parseXmlDocument = (
    content: string,
    errorMessage: string = 'Could not parse XML.',
    contentType: DOMParserSupportedType = XML_FILE_TYPE,
    parser: DomParserLike = new DOMParser()
): Document => {
    const document: Document = parseXmlWithDomParser(content, contentType, parser);
    if (hasXmlParseErrorElement(document)) throw new Error(errorMessage);
    return document;
};

export const serializeXmlDocument = (document: Document): string => {
    const Serializer: typeof XMLSerializer | undefined =
        document.defaultView?.XMLSerializer ?? (typeof XMLSerializer !== 'undefined' ? XMLSerializer : undefined);
    if (!Serializer) throw new Error('XMLSerializer is not available for this XML document.');
    return new Serializer().serializeToString(document);
};
